// Gorgias Chat Event Listener
var initGorgiasChatPromise = (window.GorgiasChat) ? window.GorgiasChat.init() : new Promise(function (resolve) { window.addEventListener('gorgias-widget-loaded', function () { resolve();})});
var eventsToTrack = [
    { gorgias: "message:sent",     dl: "gorgias_message_sent" },
    { gorgias: "message:received", dl: "gorgias_message_received" },
    { gorgias: "widget:opened",    dl: "gorgias_widget_opened" },
    { gorgias: "widget:closed",    dl: "gorgias_widget_closed" }
];

initGorgiasChatPromise.then(function() {

      eventsToTrack.forEach(function (evt) {
        GorgiasChat.on(evt.gorgias, function (data) {
          Shopify.analytics.publish(evt.dl, {
            gorgias_event: evt.gorgias,
            gorgias_data: data || null
          });  
        });
      });

})

// CTA Primary Button Click Event Listener
document.addEventListener('click', function(event) {
  const btn = event.target.closest('.button.button--primary');

  if (btn) {
    Shopify.analytics.publish('cta_button_click', {
      link_url: btn.href || btn.getAttribute('action') || 'no-link',
      link_text: btn.innerText.trim(),
      page_location: window.location.href,
      link_target: btn.getAttribute('target') || '_self'
    });
  }
}, { passive: true });